import { motion, useScroll, useSpring, useTransform } from "framer-motion";

const HOME_STOPS = [0, 0.07, 0.13, 0.22, 0.34, 0.46, 0.56, 0.68, 0.8, 0.92, 1];
const HOME_XS = ["76%", "66%", "12%", "86%", "8%", "84%", "88%", "10%", "78%", "14%", "84%"];
const HOME_YS = ["28%", "62%", "24%", "14%", "68%", "20%", "62%", "30%", "70%", "50%", "22%"];

const Butterfly = () => (
  <svg
    viewBox="0 0 48 48"
    className="h-full w-full"
    fill="none"
    aria-hidden="true"
    style={{ filter: "drop-shadow(0 0 6px rgba(210,55,139,0.55))" }}
  >
    {/* left wings */}
    <g className="wing-l">
      <path
        d="M22 22 L6 8 L10 20 L16 23 Z"
        stroke="#D2378B"
        strokeWidth="1.2"
        fill="rgba(210,55,139,0.16)"
        strokeLinejoin="round"
      />
      <path
        d="M22 26 L4 30 L12 38 L18 30 Z"
        stroke="#D2378B"
        strokeWidth="1.2"
        fill="rgba(210,55,139,0.1)"
        strokeLinejoin="round"
      />
      <path d="M9 12 L14 21" stroke="#D2378B" strokeWidth="0.6" opacity="0.6" />
    </g>
    {/* right wings */}
    <g className="wing-r">
      <path
        d="M26 22 L42 8 L38 20 L32 23 Z"
        stroke="#D2378B"
        strokeWidth="1.2"
        fill="rgba(210,55,139,0.16)"
        strokeLinejoin="round"
      />
      <path
        d="M26 26 L44 30 L36 38 L30 30 Z"
        stroke="#D2378B"
        strokeWidth="1.2"
        fill="rgba(210,55,139,0.1)"
        strokeLinejoin="round"
      />
      <path d="M39 12 L34 21" stroke="#D2378B" strokeWidth="0.6" opacity="0.6" />
    </g>
    {/* body */}
    <path d="M24 14 L24 34" stroke="#FFFFFF" strokeWidth="1.4" strokeLinecap="round" />
    <path d="M24 14 L20 9 M24 14 L28 9" stroke="#FFFFFF" strokeWidth="0.8" opacity="0.7" />
    <circle cx="24" cy="24" r="1.4" fill="#D2378B" />
  </svg>
);

const TwinButterfly = ({ stops = HOME_STOPS, xs = HOME_XS, ys = HOME_YS }) => {
  const { scrollYProgress } = useScroll();
  const p = useSpring(scrollYProgress, { stiffness: 42, damping: 16, mass: 0.6 });
  const left = useTransform(p, stops, xs);
  const top = useTransform(p, stops, ys);
  const rotate = useTransform(
    p,
    [0, 0.15, 0.3, 0.45, 0.6, 0.75, 0.9, 1],
    [-8, 10, -12, 8, -10, 12, -6, 8]
  );

  return (
    <motion.div
      data-testid="twin-butterfly"
      style={{ left, top, rotate }}
      className="pointer-events-none fixed z-40 h-8 w-8 md:h-11 md:w-11"
      aria-hidden="true"
    >
      <motion.div
        animate={{ y: [0, -7, 0, 5, 0], x: [0, 4, 0, -4, 0] }}
        transition={{ duration: 6.5, repeat: Infinity, ease: "easeInOut" }}
        className="h-full w-full"
      >
        <Butterfly />
      </motion.div>
    </motion.div>
  );
};

export default TwinButterfly;
